import { useEffect } from "react";
import { Outlet } from "react-router-dom";
import { toAbsoluteUrl } from "../../../_metronic/helpers";
import { LoginPageThemeModeSwitcher } from "../../../_metronic/partials/layout/theme-mode/LoginPageThemeModeSwitcher";
import clsx from "clsx";
import { AuthLayoutLanguages } from "../../../_metronic/partials/layout/AuthLayoutLanguages";
import { ThemeModeProvider } from "../../../_metronic/partials";
import { useIntl } from "react-intl";

const AuthLayoutCompanies = () => {
  const intl = useIntl();
  useEffect(() => {
    const root = document.getElementById("root");
    if (root) {
      root.style.height = "100%";
    }
    return () => {
      if (root) {
        root.style.height = "auto";
      }
    };
  }, []);

  return (
    <ThemeModeProvider>
      <div className="d-flex flex-column flex-lg-row flex-column-fluid h-100">
        <div className="d-flex flex-column flex-lg-row-fluid w-lg-50 p-10 order-2 order-lg-1">
          <div className="d-flex flex-center flex-column flex-lg-row-fluid">
            <div className="w-lg-500px p-10">
              <Outlet />
            </div>
          </div>
          <div className="d-flex justify-content-center ">
            <div className="d-flex fw-semibold text-primary fs-base">
              <p className="px-5">
                {intl.formatMessage({
                  id: "LOGINPAGE.OPTIONS.TERMS",
                })}
              </p>

              <p className="px-5">
                {intl.formatMessage({
                  id: "LOGINPAGE.OPTIONS.CONTACTUS",
                })}
              </p>
            </div>
          </div>
        </div>

        <div
          className="d-none d-lg-flex flex-lg-row-fluid w-50 bgi-size-cover bgi-position-y-center bgi-position-x-start bgi-no-repeat"
          style={{
            backgroundImage: `url(${toAbsoluteUrl(
              "/media/auth/bg9-dark.jpg"
            )})`,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            backgroundPosition: "center center",
            backgroundRepeat: "no-repeat",
          }}
        >
          <a
            href="https://aacceson.com"
            className="justify-content-center align-items-center"
          >
            <img
              alt="Logo"
              src={toAbsoluteUrl("/media/logos/logo_white.png")}
              className="h-200px"
            />
          </a>
          <p
            className="text-white"
            style={{ fontSize: "20px", marginTop: "-25px" }}
          >
            {intl.formatMessage({
              id: "LOGINPAGE.SUBTITLE.AACCESON.COMPANIES",
            })}
          </p>
        </div>

        <div className="d-flex w-100 justify-content-between bg-transparent position-absolute">
          <LoginPageThemeModeSwitcher
            toggleBtnClass={clsx(
              "btn-active-light-primary m-2 btn-custom text-white"
            )}
          />
          <AuthLayoutLanguages />
        </div>
      </div>
    </ThemeModeProvider>
  );
};

export { AuthLayoutCompanies };
